export const TIMESHIFTER_REDIRECT_URL = 'https://www.timeshifter.com/';
